export default {
  FETCH_IMAGES_CONFIG: 'FETCH_IMAGES_CONFIG',
  FETCH_IMAGES_CONFIG_START: 'FETCH_IMAGES_CONFIG_START',
  FETCH_IMAGES_CONFIG_SUCCESS: 'FETCH_IMAGES_CONFIG_SUCCESS',
  FETCH_IMAGES_CONFIG_FAILURE: 'FETCH_IMAGES_CONFIG_FAILURE',
  FETCH_ALL_GENRES: 'FETCH_ALL_GENRES',
  FETCH_ALL_GENRES_START: 'FETCH_ALL_GENRES_START',
  FETCH_ALL_GENRES_SUCCESS: 'FETCH_ALL_GENRES_SUCCESS',
  FETCH_ALL_GENRES_FAILURE: 'FETCH_ALL_GENRES_FAILURE',
};
